import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { Link, useLocation } from "react-router-dom";
import { useRouteInfo } from "../hooks/useRouteInfo";

const AboutPage = () => {
  const { metaData } = useRouteInfo();

  return (
    <div className="container_1 py-8">
      <Helmet>
        <meta charSet="utf-8" />
        <title>{metaData?.meta_title}</title>
        <meta name="description" content={metaData?.meta_desc} />
        <meta name="og:description" content={metaData?.meta_desc} />
        <meta name="og:title" content={metaData?.meta_title} />
        <link rel="canonical" href={metaData?.canonical} />
        <meta property="og:type" content={metaData?.meta_type} />
      </Helmet>{" "}
      <div className="mb-12 mt-6">
        <span className="flex justify-between">
          <h1 className="title">{metaData?.h1}</h1>
          <Link to={"/faq"} className="btn-brand">
            سوالات متداول
          </Link>
        </span>

        <p className="desc">
          ماشین سنگین فقط وسیله‌ٔ نقلیه نیست، یک سبک زندگی کامل است. یاوری است
          که کیلومترها با او سفر کرده‌ایم، بارهای سنگین زندگی را روی دوش او
          گذاشته‌ایم و نمی‌خواهیم او را به ارزانی از دست بدهید یا بدون شناخت به
          طولانی‌ترین روزهای زندگی‌تان اضافه کنید.
        </p>
      </div>
      <div className="mb-6 mt-6 pr-4 yellow-circle relative dashed-right">
        <h4 className="text-[22px] font-bold pt-2">
          ما جمعی از دوستداران ماشین‌های سنگین هستیم که سال‌های طولانی در
          بخش‌های مختلف این حوزه گذراندیم
        </h4>
        <img
          src="/about1.jpg"
          className="w-full object-cover my-8 rounded-[10px] center"
          alt=""
        />
      </div>
      <div className="mb-6 mt-6 pr-4 yellow-circle relative  dashed-right">
        <h4 className="text-[22px] font-bold pt-2">
          بارها از قیمت‌گذاری‌های غیرمنصفانه گیج شدیم، ماشین‌های عزیزتر از
          جان‌مان را به بهای ارزان فروختیم، با اعتماد به واسطه‌گران بارها زمین
          خوردیم.
        </h4>
        <img
          src="/about2.jpg"
          className="w-full  object-cover my-8 rounded-[10px] center"
          alt=""
        />
      </div>
      <div className="mb-6 mt-6 pr-4 yellow-circle relative">
        <h4 className="text-[22px] font-bold pt-2">
          سپس بارهای بیشتری دست روی زانوی و پا روی کلاچ گذاشتیم و دوباره به راه
          افتادیم تا نگذاریم دیگران از همین مسیر بگذرند. این بار به راه‌
          افتاده‌ایم تا درد مشترک را به راه‌حلی مشترک تبدیل کنیم: پلتفرمی امن و
          قانونمند برای خرید و فروش منصفانه خودروهای سنگین کارکرده!
        </h4>
        <img
          src="/p1.png"
          className="w-full max-h-[330px] object-cover my-8 rounded-[10px] center"
          alt=""
        />
      </div>
      <div className="mb-12 mt-6">
        <h2 className="title">کوتاه‌ترین راه خرید ماشین رویایی</h2>
        <p className="desc">
          دوست داریم که در رسیدن به رویاهایتان، همراه باشیم و مسیر را برایتان
          هموار کنیم. برای این همراهی اقدامات زیر را در نظر می‌گیریم:
        </p>
        <div className="my-6 px-4">
          <h4 className="text-[22px] font-bold pt-2">
            1. امکان معاوضه و ارتقا خودروی سنگین
          </h4>
          <p className="desc">
            اگر قصد شما از فروش، ارتقا به خودرویی بهتر (و البته گران‌تر) است، از
            تصمیم شما حمایت می‌کنیم. خودروی قدیمی را به‌عنوان بخشی از مبلغ
            می‌پذیریم و برای باقیمانده، اقساط متناسب با شما تعریف می‌کنیم.{" "}
          </p>
        </div>
        <div className="my-6 px-4">
          <h4 className="text-[22px] font-bold pt-2">
            ۲. شرایط اقساطی منصفانه
          </h4>
          <p className="desc">
            خرید خودروی سنگین، هزینه‌های سنگینی را هم در بر دارند. برخلاف
            لیزینگ‌ها و سایر تسهیلات خودروی نو، برای خودروی کارکرده نیز اقساط
            بلندمدت و کم‌سود تعریف کرده‌ایم.
          </p>
        </div>
        <div className="my-6 px-4">
          <h4 className="text-[22px] font-bold pt-2">
            ۳. شیرینی پس از خرید با ما
          </h4>
          <p className="desc">
            رانندگانی که با همراهی ما به خودروی دلخواه خود می‌رسند را با در نظر
            گرفتن برخی تسهیلات و هدایا نظیر اولین کارواش، بیمه و …حمایت می‌کنیم.
          </p>
        </div>
      </div>
      <div className="grid  gap-7 my-8 items-center">
        <span>
          <img
            src="/about4.jpg"
            className="  w-[100%]  object-cover rounded-[10px] center"
            alt=""
          />
        </span>
      </div>{" "}
      <div className="mb-12 mt-6">
        <h2 className="title">یک فروش امن و بی‌ضرر</h2>
        <p className="desc">
          برای آن دسته از همراهانی که در اعتماد به واسطه‌گران بازار ناامن
          خودروهای سنگین، دچار سردرگمی و نگرانی شده‌اند هم چاره داریم. تلاش ما
          بر این است که جدایی از همراه همیشگی‌تان را ساده‌تر کنیم:
        </p>
        <div className="my-6 px-4">
          <h4 className="text-[22px] font-bold pt-2">
            ۱. فروش در کوتاه‌ترین زمان ممکن
          </h4>
          <p className="desc">
            وبسایت تخصصی ثبت آگهی، صفحات اجتماعی پربازدید و ارتباطات کاری گسترده
            ما را در فروش سریع خودروی شما یاری می‌کنند.
          </p>
        </div>
        <div className="my-6 px-4">
          <h4 className="text-[22px] font-bold pt-2">
            ۲. کارشناسی دقیق قیمت خودرو
          </h4>
          <p className="desc">
            خودروهای پیشنهادی ۱۹۲۴ از فیلترهای زیادی رد می‌شوند، از بررسی فنی و
            کارشناسی رنگ گرفته تا قیمت منصفانه همه‌چیز را پیش از معرفی به شما
            بررسی می‌کنیم.
          </p>
        </div>
      </div>
      <img
        src="/about5.jpg"
        className="w-full  object-cover my-10 rounded-[10px] center"
        alt=""
      />
    </div>
  );
};

export default AboutPage;
